var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "icon icon__account",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.737 7.237a4.737 4.737 0 1 1-9.474 0 4.737 4.737 0 0 1 9.474 0Zm-1.58 0a3.158 3.158 0 1 1-6.315 0 3.158 3.158 0 0 1 6.316 0Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.579 15.579H10.42A6.921 6.921 0 0 0 3.5 22.5H2c0-4.65 3.77-8.421 8.421-8.421h3.158c4.65 0 8.421 3.77 8.421 8.421h-1.5a6.921 6.921 0 0 0-6.921-6.921Z"
})));
export default SvgAccount;